import { useState, useEffect } from "react";
import { GOOGLE_CLIENT_ID, googleLogin } from "../services/api";

export default function Login({ setIsAuthenticated, onLogin }) {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const initializeGoogleSignIn = () => {
      if (window.google) {
        window.google.accounts.id.initialize({
          client_id: GOOGLE_CLIENT_ID,
          callback: handleGoogleResponse,
        });

        window.google.accounts.id.renderButton(
          document.getElementById("google-signin-button"),
          {
            theme: "outline",
            size: "large",
            width: 320,
            text: "signin_with",
          }
        );
      } else {
        // Retry after 100ms if Google script not loaded
        setTimeout(initializeGoogleSignIn, 100);
      }
    };

    initializeGoogleSignIn();
  }, []);

  const handleGoogleResponse = async (response) => {
    setLoading(true);
    setError("");

    try {
      const result = await googleLogin({ id_token: response.credential });
      console.log("Login result:", result); // Debug log
      localStorage.setItem("companioToken", result.access_token);
      setIsAuthenticated(true);
      if (onLogin) {
        onLogin(result.user);
      }
    } catch (err) {
      console.error("Login error:", err); // Debug log
      setError(err.response?.data?.detail || "Google login failed");
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = (event) => {
    event.preventDefault();
    setIsAuthenticated(true);
  };

  return (
    <main className="login">
      <section className="login-card">
        <div className="login-header" style={{ textAlign: "center" }}>
          <span className="badge">Companio Audio Lab</span>
          <h1>Fast, focused annotation.</h1>
          <p>
            Log in to review your stacked audio tasks, accept or edit the
            transcript, and capture age + emotion signals.
          </p>
        </div>
        <form className="login-form" onSubmit={handleLogin}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <div id="google-signin-button"></div>
            {loading && (
              <div style={{ color: "#666", fontSize: "0.9rem" }}>
                Signing in...
              </div>
            )}
            {error && (
              <div
                style={{
                  color: "red",
                  fontSize: "0.9rem",
                  textAlign: "center",
                }}
              >
                {error}
              </div>
            )}
          </div>

          {/* Username/Password login - commented for future use
          <div style={{margin: '20px 0', textAlign: 'center', color: '#999'}}>or</div>
          
          <label>
            Name
            <input
              value={userName}
              onChange={(event) => setUserName(event.target.value)}
              placeholder="Enter your name"
              required
            />
          </label>
          <label>
            Access code
            <input type="password" placeholder="••••••••" required />
          </label>
          <button type="submit">Start annotating</button>
          */}
        </form>
        {/* Login meta stats - commented for future use
        <div className="login-meta" style={{ textAlign: 'center' }}>
          <div>
            <strong>Today</strong>
            <span>24 queued clips</span>
          </div>
          <div>
            <strong>Last payout</strong>
            <span>$86.40</span>
          </div>
          <div>
            <strong>Accuracy</strong>
            <span>98.1%</span>
          </div>
        </div>
        */}
      </section>
    </main>
  );
}
